import React, { useState, useContext } from "react";
import { AuthContext } from "../App";
import { Button } from "./ui/button";
import { LockKeyhole } from "lucide-react";
import { SubscribeDialog } from "./demo/SubscribeDialog";

export default function DemoExpired() {
  const { logout, user } = useContext(AuthContext);
  const [subOpen, setSubOpen] = useState(false);
  const expiryStr = user?.demo_expires
    ? new Date(user.demo_expires).toLocaleDateString("en-AU", { day: "numeric", month: "short", year: "numeric" })
    : "";

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center px-4" data-testid="demo-expired-page">
      <div className="w-full max-w-md text-center">
        <div className="w-16 h-16 rounded-2xl bg-slate-800 flex items-center justify-center mx-auto">
          <LockKeyhole className="w-8 h-8 text-amber-400" />
        </div>
        <h1 className="text-2xl font-bold text-white mt-5">
          Your trial {expiryStr ? `ended on ${expiryStr}` : "has ended"}.
        </h1>
        <p className="text-slate-400 mt-3">Your site data has been deleted as notified.</p>

        <Button
          onClick={() => setSubOpen(true)}
          className="mt-6 w-full h-12 text-base bg-amber-500 hover:bg-amber-600 font-semibold"
          data-testid="demo-expired-subscribe-btn"
        >
          Subscribe to Reactivate
        </Button>
        <p className="text-xs text-slate-500 mt-3">
          Starting a subscription creates a fresh account. Trial data cannot be recovered.
        </p>
        <p className="text-sm text-slate-400 mt-6">
          Questions? Call Chris on 0410 344 600 or reply to your trial emails.
        </p>
        <button onClick={logout} className="text-slate-500 underline text-sm mt-6" data-testid="demo-expired-logout-btn">
          Back to login
        </button>
      </div>
      <SubscribeDialog open={subOpen} onClose={() => setSubOpen(false)} />
    </div>
  );
}
